import React from "react";

type HiddenFileInputProps = {
  onChange: (files: FileList | null) => void;
};

export const HiddenFileInput = React.forwardRef<
  HTMLInputElement,
  HiddenFileInputProps
>(({ onChange }, ref) => (
  <input
    ref={ref}
    type="file"
    accept=".csv,text/csv"
    className="hidden"
    onChange={(e) => onChange(e.target.files)}
  />
));
